import React from 'react'
import List from './List'
import Card from 'src/components/Card'
import { useEeocContext } from './useEeoc'
import SendModal from './SendModal'
import VoidModal from './VoidModal'
import Viewer from './Viewer'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const { eeoc, actions } = useEeocContext()

  return (
    <>
      <Card
        title='EEOC Paperwork'
        primaryAction={actions.primary}
        secondaryActions={actions.secondary}
      >
        <List eeoc={eeoc} />
      </Card>
      <SendModal id={id} />
      <VoidModal id={id} />
      <Viewer />
    </>
  )
}

export default Body
